import { ActionTree } from "vuex";
import { RoleActionsTypes, RoleMutationsTypes } from "./types";
import { Role, RoleActions, RoleState } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<RoleState, RoleState> & RoleActions = {
  [RoleActionsTypes.LIST_ROLE]: async ({ commit }): Promise<void> => {
    return Client.get<number, Response_>(`role/`)
      .then((response: Response_) => {
        commit(RoleMutationsTypes.SET_ROLE, response.body as Array<Role>);
        return response.status;
      })
      .catch((err) => err);
  }
};
